import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";

var filter = require("lodash.filter");

export var filterNodes = function filterNodes(data, filters) {
  var mainProperty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "title";
  var key = Object.keys(data)[0];
  var nodes = data[key].nodes;
  if (!nodes) return [];

  if (typeof filters === "string") {
    filters = _defineProperty({}, mainProperty, filters);
  }

  return filter(nodes, filters);
}; // See https://github.com/sindresorhus/is-absolute-url

export var isAbsoluteUrl = function isAbsoluteUrl(url) {
  if (typeof url !== "string") {
    throw new TypeError("Expected a `string`, got `".concat(typeof url, "`"));
  } // Don't match Windows paths `c:\`


  if (/^[a-zA-Z]:\\/.test(url)) {
    return false;
  } // Scheme: https://tools.ietf.org/html/rfc3986#section-3.1
  // Absolute URL: https://tools.ietf.org/html/rfc3986#section-4.3


  return /^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(url);
};
export var isRelativeUrl = function isRelativeUrl(url) {
  return !isAbsoluteUrl(url);
};
export var absoluteUrl = function absoluteUrl(path, url) {
  return path ? "".concat(url, "/").concat(path.replace(/^\/+/, "")) : url;
};